// Deprecated. Please refrain from new usage
import PropTypes from "prop-types";
import React from "react";

import MuiTypography from "@material-ui/core/Typography";
import { withTheme } from "@material-ui/core/styles";

const variants = [
  "subtitle1",
  "subtitle2",
  "body1",
  "body2",
  "caption",
  "button",
  "overline",
  "srOnly",
  "inherit",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "subheading",
];

export const Typography = (props) => {
  const determineColor = (variant, color) => {
    if (variant === "bold") {
      return null;
    }

    if (color != null) {
      return props.theme.palette.text[color];
    }

    return props.theme.palette.text.primary;
  };

  const determineVariant = (variant) => (variants.includes(variant) ? variant : null);

  const style = {
    ...props.style,
    color: determineColor(props.variant, props.color),
    fontWeight: props.variant === "bold" ? 700 : null,
  };

  return (
    <MuiTypography
      variant={determineVariant(props.variant)}
      style={style}
      component={props.component}
      className={props.className}
    >
      {props.children}
    </MuiTypography>
  );
};

Typography.propTypes = {
  variant: PropTypes.oneOf([
    ...variants,
    "bold",
    "smallLabel",
    "label",
    "bigLabel",
    "modalTitle",
    "info",
    "decoder",
  ]),
  theme: PropTypes.object.isRequired,
  color: PropTypes.string,
  children: PropTypes.node,
  component: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

Typography.defaultProps = {
  variant: "body2",
  color: null,
  children: <span />,
  component: "span",
  style: {},
  className: null,
};

export default withTheme(Typography);
